/**
 * @typedef {Object} DangerouslySetInnerHTML
 * @property {string} __html - The formatted HTML string
 */

/**
 * Formats a HTML String to use with dangerouslySetInnerHTML react prop
 * @param text HTML raw string to format
 * @returns {DangerouslySetInnerHTML} Returns the {@link DangerouslySetInnerHTML} formatted HTML string object
 */
export const decorateEditorialHtml = (text?: string) => {
  if (!text) {
    return { __html: '' };
  }

  const htmlWithStyle = text
    .replace(/<h[1-9]/gi, '$& class="uitk-type-heading-500"')
    .replace(/<br>/gi, '')
    .replace(/<br\/>/gi, '')
    .replace(/<\/br>/gi, '')
    .replace(/<ul/gi, '$& class="uitk-type-list-300 all-t-margin-two"')
    .replace(/<p/gi, '<div class="uitk-type-paragraph-300 all-t-margin-two"')
    .replace(/<\/p>/gi, '</div>');

  return { __html: htmlWithStyle };
};
